export default __webpack_public_path__ + "static/media/logo-mini.a916199c.svg";